import { render, staticRenderFns } from "./PostcodeMap.vue?vue&type=template&id=6e9e5475&scoped=true&"
import script from "./PostcodeMap.vue?vue&type=script&lang=js&"
export * from "./PostcodeMap.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeMap.vue?vue&type=style&index=0&id=6e9e5475&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9e5475",
  null
  
)

export default component.exports